import './Css/bootstrap.min.css';
import './Css/Taskbar.css';
import './App.css';
import Production from "./Production/index";
import CRM from "./CRM/index";
import Sale from "./Sale/index";
import Login from './Pages/login';
import BaseInfo from './BaseInfo';
import Office from './Office/index';
import HomePage from './Pages/index';
import Services from './Services/index';
import Footer from './Components/footer';
import Loader from 'react-loader-spinner';
import Accounting from './Accounting/index';
import Projects from "./Projects/index";
import Menu from './Components/Header/Menu';
import PrintViewer from "./Pages/PrintViewer";
import UserProfile from './Pages/UserProfile';
import MenuWide from './Components/Header/MenuWide';
import SearchCommands from './Pages/SearchCommands';
import AddEditCustomer from './CRM/pages/AddEditCustomer';
import ModalDialog from './Components/Modals/ModalDialog';
import BackButton from './Services/Components/Header/Back';
import ModalAboutUs from './Components/Modals/ModalAboutUs';
import NotificationArea from './Components/NotificationArea';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCallback, useEffect, useState, Fragment, useRef } from 'react';
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import { GeoAltFill, Globe2, PersonCircle, Telephone } from 'react-bootstrap-icons';
import { faToolbox, faFileInvoice, faSitemap, faTimesCircle, faHeadset, faCalculator, faList } from '@fortawesome/free-solid-svg-icons'
import SMSInvoice from './Sale/pages/SMSInvoice';
import { getActiveSubsystems, getCurrentUserQuickAccess, deleteQuickAccess, checkModule, systemModules, getCurrentDurationName, serverUrl, useIsMobileApp, test } from './store/api/CommonFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { getAppConfig } from './store/api/SystemSettingsAPI';
import UserDashboard from './Pages/UserDashboard';
import Contacts from './Pages/Contacts';
import ModalSMSTemplates from './Components/Modals/ModalSMSTemplates';
import SearchSentSMS from "./Pages/SearchSentSMS";
import SearchReceivedSMS from "./Pages/SearchReceivedSMS";
import LocationSender from './Components/LocationSender';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import PushNotificationManager from './Components/PushNotificationManager';
import ModalUnreadReminders from './Components/Modals/ModalUnreadReminders';
import ModalExtendGuarantee from './Components/Modals/ModalExtendGuarantee';
import ActionHistory from "./Pages/ActionHistory/ActionHistory";


const requireAuth = (setUser, user) => {
  const token = localStorage.getItem('token');
  if (token !== null && token) {
    setUser(token);
  } else if (user !== null) {
    setUser(null);
  }
}
/* eslint-disable no-restricted-globals */
(function () {
  const pushState = history.pushState;
  history.pushState = function () {
    const result = pushState.apply(this, arguments);
    window.dispatchEvent(new Event("locationchange"));
    return result;
  };

  const replaceState = history.replaceState;
  history.replaceState = function () {
    const result = replaceState.apply(this, arguments);
    window.dispatchEvent(new Event("locationchange"));
    return result;
  };

  window.addEventListener("popstate", () => {
    window.dispatchEvent(new Event("locationchange"));
  });
})();

function App() {
  const dispatch = useDispatch();
  const [hideMenu, setHideMenu] = useState(false);
  const [menuName, setMenuName] = useState("Main");
  const [pending, setPending] = useState(true);
  const [currentUser, setUser] = useState(null);
  const [forgetPassword, setForgetPassword] = useState(false);
  const [menuWidth, setMenuWidth] = useState("0");
  const [taskbarWidth, setTaskbarWidth] = useState("0");
  const [showAboutUs, setModalAboutUs] = useState(false);
  const [modalUnreadReminders, setModalUnreadReminders] = useState({ show: false });
  const isMobile = useIsMobileApp();
  const userInfo = JSON.parse(localStorage.getItem("UserInfo"));
  const company = JSON.parse(localStorage.getItem("Company")) ?? {};
  const isNotifActive = JSON.parse(localStorage.getItem("PushNotifIsActive"));
  const { activeSS, appModules } = useSelector(state => {
    return {
      activeSS: state.SystemSettingsReducer.activeSubsystems?.Data,
      appModules: state.SystemSettingsReducer.appModules?.Data
    }
  });
  const activeMenuList = activeSS?.MenuAccessNumber?.split?.('-');
  const [QAList, setQAList] = useState({ Data: [] });
  let saleQA = [];
  let accQA = [];
  let crmQA = [];
  let serviceQA = [];
  let officeQA = [];
  let baseInfoQA = [];
  if (QAList?.Data && Array.isArray(QAList.Data)) {
    saleQA = QAList.Data.filter(q => q.SubSystemName === "Sale");
    accQA = QAList.Data.filter(q => q.SubSystemName === "Accounting");
    crmQA = QAList.Data.filter(q => q.SubSystemName === "CRM");
    serviceQA = QAList.Data.filter(q => q.SubSystemName === "Services");
    officeQA = QAList.Data.filter(q => q.SubSystemName === "Office");
    baseInfoQA = QAList.Data.filter(q => q.SubSystemName === "BaseInfo");
  }
  const popCompanyInfo = (
    <Popover style={{ fontFamily: "Vazir", fontSize: "12px", maxWidth: "fit-content" }}>
      <Popover.Title className='headerStyle'>درباره شرکت</Popover.Title>
      <Popover.Content className='bodyStyle' style={{ textAlign: "center", fontSize: "12px", color: "blue", paddingBottom: "5px" }}>
        <img src={process.env.PUBLIC_URL + "/images/headerLogo.png"} height={80} alt='' />
        <div style={{ fontSize: "14px" }}>{company.CompanyName}</div>
        <div><GeoAltFill /> نشانی: {company.CompanyAddress}</div>
        <div><Telephone /> تلفن: {company.Phone}</div>
        <div style={{ direction: "ltr" }}><a href={company?.WebSite}><Globe2 /> {company.WebSite}</a></div>
        <div className='mt-3' style={{ fontSize: "10px", color: "#264e85", fontStyle: "italic" }}>Powered By Bihamta</div>
        <div style={{ fontSize: "9px", color: "#264e85", fontStyle: "italic" }}>تهیه و تولید از شرکت هورماه </div>
      </Popover.Content>
    </Popover>
  )
  const checkSS = useCallback((code) => {
    if (activeMenuList?.length > 0) {
      for (var m in activeMenuList) {
        const menu = activeMenuList[m].split(',');
        if (Number(menu[0]) === Number(code)) {
          return true;
        }
      };
      return false;
    }
    return true;

  }, [activeMenuList]);

  function openTaskbar() {
    const act = document.getElementById("activator");
    const svg = act.querySelector("svg");
    const taskMenu = document.querySelector(".taskBarMenu");

    if (taskbarWidth !== "0") {
      act.classList.remove("openedActivator");
      svg.classList.remove("fa-3x");
      svg.classList.add("fa-2x");
      taskMenu.style.borderRadius = "100% 100% 100% 100%";
      taskMenu.style.right = "40px";
      taskMenu.style.overflow = "hidden";
      taskMenu.style.minHeight = "0px";
      taskMenu.style.maxHeight = "0px";
      taskMenu.style.zIndex = -1;
      taskMenu.querySelectorAll("svg").forEach(s => s.style.visibility = "hidden");

    }
    else {
      act.classList.add("openedActivator");
      svg.classList.remove("fa-2x");
      svg.classList.add("fa-3x");
      taskMenu.style.borderRadius = "3px";
      taskMenu.style.overflow = "visible";
      taskMenu.style.right = "67px";
      taskMenu.style.minHeight = "67px";
      taskMenu.style.maxHeight = "450px";
      taskMenu.style.zIndex = 0;
      taskMenu.querySelectorAll("svg").forEach(s => s.style.visibility = "visible");
    }
    var c = taskMenu.querySelectorAll(".mainItem");

    setTaskbarWidth(taskbarWidth === "0" ? (c.length * 55 + "px") : "0")
  }
  function removeMenu(pageUrl) {
    deleteQuickAccess(pageUrl, setQAList);
  }
  function checkPath()
  {
    const pathname = window.location.pathname;
    return (pathname === "/" && (userInfo?.HomePage ?? "") === "") 
           || window.location.pathname === "/UserDashboard"
           || window.location.pathname ==="/SearchCommands";
  }
  useEffect(() => {
    requireAuth(setUser, currentUser);
    setPending(false);
    if (currentUser) {
      setModalUnreadReminders({ show: true });
      dispatch(getAppConfig());
      dispatch(getActiveSubsystems());

      getCurrentUserQuickAccess(setQAList);
    }
  }, [currentUser]);
  useEffect(() => {
    const handleRouteChange = () => {
      if (currentUser && !modalUnreadReminders?.show) {
        setModalUnreadReminders({ show: true });
      }
      
      if (checkPath()) {
        setHideMenu(false);
      }
      else {
        setHideMenu(true);
      }
    };

    handleRouteChange();

    window.addEventListener("locationchange", handleRouteChange);

    return () => {
      window.removeEventListener("locationchange", handleRouteChange);
    };
  }, [])
  return (
    <div className="App">
      <LocationSender />
      {isNotifActive && <PushNotificationManager currentUser={currentUser} />}
      <ModalUnreadReminders popData={modalUnreadReminders} setPopData={setModalUnreadReminders} />
      <Router>
        <ModalDialog />
        {window.location.href.contains("SMSInvoice") &&
          <Switch>
            <Route path="/Sale/SMSInvoice/:invoiceNumber/:durationID/:mobile/:serverUrl"><SMSInvoice /></Route>
            <Route path="/PrintViewer/:reportName/:designMode"><PrintViewer /></Route>
          </Switch>
        }
        {currentUser && !window.location.href.contains("SMSInvoice") &&
          <Fragment>
            <div className="row" style={{ direction: "ltr" }}>
            </div>
            <ModalAboutUs show={showAboutUs} setModalAboutUs={setModalAboutUs} />
            <div className="pageTitle" style={{ position: "relative", height: "max-content", display: "flex", paddingRight: "12px", paddingLeft: "12px" }}>
              {isMobile && !window.location.href.contains("SMSInvoice") && !hideMenu &&
                <Menu menuName="Main" showHamburger={menuName === "Main"} />}
              <label>
                {!isMobile && !window.location.href.contains("SMSInvoice")
                  && (window.location.pathname === '/' || 
                      window.location.pathname === '' || 
                      window.location.pathname === "/UserDashboard"||
                      window.location.pathname === "/SearchCommands"
                    ) &&

                  <Fragment>
                    {!hideMenu && <label style={{ fontSize: "30px", cursor: "pointer", position: "relative", zIndex: 1 }} onClick={() => { setMenuWidth("250px") }}>&#9776;</label>}
                    <MenuWide menuWidth={menuWidth} setMenuWidth={setMenuWidth} currentUser={currentUser} setModalAboutUs={setModalAboutUs} menuName={menuName} setQAList={setQAList} />
                  </Fragment>}
                {!window.location.href.contains("SMSInvoice") &&
                  <div style={{ display: "inline-block", position: "absolute", right: "50px", top: "12px", zIndex: 1 }}>
                    <a href="/UserProfile">
                      <PersonCircle id='PersonIcon' color='white' size={22} style={{ transform: "translateY(-35%)" }} />
                      <label id="UserName" style={{ marginRight: "5px", color: "white", maxWidth: "120px", overflow: "hidden", position: "relative" }}>{userInfo?.Name}</label>
                    </a>
                  </div>
                }
              </label>
              {window.innerWidth > 414 && !window.location.href.contains("SMSInvoice") &&

                <label className='centerLabel titleLabel animate-charcter' id="CompanyName" companyname={company.CompanyName} systemname="صفحه اصلی" style={{ top: 8, fontSize: "17px", fontWeight: "bold", color: "white" }}>
                  <OverlayTrigger overlay={popCompanyInfo} trigger="click" rootClose placement='bottom'>
                    <img src={process.env.PUBLIC_URL + "/images/headerLogo.png"} onError={(e) => {
                      if (!e.currentTarget.dataset.fallback) {
                        e.currentTarget.dataset.fallback = "true";
                        e.currentTarget.src = company?.CompanyLogo || "";
                      }
                    }}
                      height={30} className='me-auto' alt=''
                      style={{ zIndex: 1, position: "relative" }} /></OverlayTrigger>
                  {company.CompanyName}<span style={{ fontSize: "13px" }}>  {getCurrentDurationName()}</span></label>

              }
              {!window.location.href.contains("SMSInvoice") &&
                <BackButton />
              }
            </div>

            <Switch>
              <Route path="/Accounting">
                {checkSS(8) && checkModule(appModules, systemModules.Finances) && <Accounting setModalAboutUs={setModalAboutUs} setQAList={setQAList} />}
              </Route>
              <Route path="/Services">
                {checkSS(64) && checkModule(appModules, systemModules.Services) && <Services setModalAboutUs={setModalAboutUs} setQAList={setQAList} />}
              </Route>
              <Route path="/BaseInfo">
                {checkSS(2) && checkModule(appModules, systemModules.BaseInfo) && <BaseInfo setModalAboutUs={setModalAboutUs} setQAList={setQAList} />}
              </Route>
              <Route path="/CRM">
                {checkSS(128) && checkModule(appModules, systemModules.CRM) && <CRM setModalAboutUs={setModalAboutUs} setQAList={setQAList} />}
              </Route>
              <Route path="/CRM/AddEditCustomer/:id">
                {checkSS(128) && checkModule(appModules, systemModules.CRM) && <AddEditCustomer />}
              </Route>
              <Route path="/Sale">
                {checkSS(16) && (checkModule(appModules, systemModules.StorageInvoice) || checkModule(appModules, systemModules.Sale)) &&
                  <Sale />}
              </Route>
              <Route path="/Office">
                {checkSS(4) && checkModule(appModules, systemModules.Office) && <Office setModalAboutUs={setModalAboutUs} setQAList={setQAList} />}
              </Route>
              <Route path="/Production">
                {checkSS(32) && checkModule(appModules, systemModules.Production) && <Production setModalAboutUs={setModalAboutUs} setQAList={setQAList} />}
              </Route>
              <Route path="/Projects">
                {checkSS(2048) && checkModule(appModules, systemModules.Projects) && <Projects setModalAboutUs={setModalAboutUs} setQAList={setQAList} />}
              </Route>
              <Route path="/UserProfile"><UserProfile /></Route>
              <Route path="/UserDashboard"><UserDashboard /></Route>
              <Route path="/PrintViewer/:reportName/:designMode"><PrintViewer /></Route>
              <Route path="/Contacts"><Contacts /></Route>
              <Route path="/SearchCommands"><SearchCommands /></Route>
              <Route path="/SMSTemplates">{checkModule(appModules, systemModules.SMSManagement) && <ModalSMSTemplates />}</Route>
              <Route path="/SearchSentSMS">{checkModule(appModules, systemModules.SMSManagement) && <SearchSentSMS />}</Route>
              <Route path="/SearchReceivedSMS">{checkModule(appModules, systemModules.SMSManagement) && <SearchReceivedSMS />}</Route>
              <Route path="/GuaranteeExtend"><ModalExtendGuarantee /> </Route>
              <Route path="/ActionHistory"><ActionHistory/></Route>
              <Route path="/">
                {userInfo?.HomePage === "Services" || userInfo?.HomePage === "AgentPanel" ? <Services setModalAboutUs={setModalAboutUs} setQAList={setQAList} /> :
                  userInfo?.HomePage === "Accounting" ? <Accounting setModalAboutUs={setModalAboutUs} /> :
                    userInfo?.HomePage === "CRM" ? <CRM setModalAboutUs={setModalAboutUs} setQAList={setQAList} /> :
                      userInfo?.HomePage === "Sale" ? <Sale setModalAboutUs={setModalAboutUs} setQAList={setQAList} /> :
                        userInfo?.HomePage === "Office" ? <Office setModalAboutUs={setModalAboutUs} setQAList={setQAList} /> :
                          userInfo?.HomePage === "Production" ? <Production setModalAboutUs={setModalAboutUs} setQAList={setQAList} /> :
                            <HomePage />
                }

              </Route>
            </Switch>

            <NotificationArea />

            <div className="activator" id="activator" onClick={openTaskbar}>
              <FontAwesomeIcon icon={faList} size='2x' color='white' />
            </div>
            <nav className="taskBarMenu" style={{ width: taskbarWidth }}>
              <ol>
                {checkSS(64) && checkModule(appModules, systemModules.Services) &&
                  <li className="menu-item mainItem">
                    <Link to="/Services">
                      <FontAwesomeIcon icon={faToolbox} size={!isMobile ? "2x" : "lg"} className='menuIcon' />
                      {/* خدمات */}
                    </Link>
                    {serviceQA.length > 0 &&
                      <ol className='sub-menu'>
                        {serviceQA.map((qa, i) =>
                          <li className="menu-item" key={i}>
                            <div dangerouslySetInnerHTML={{ __html: qa.Icon }} style={{ textAlign: "center" }}></div>
                            <a href={qa.PageUrl}>{qa.Title}</a> &nbsp;
                            <FontAwesomeIcon icon={faTimesCircle} color='red' onClick={() => removeMenu(qa.PageUrl)} className='mt-1' />
                          </li>
                        )}
                      </ol>
                    }
                  </li>
                }
                {checkSS(8) && checkModule(appModules, systemModules.Finances) &&
                  <li className="menu-item mainItem">
                    <Link to="/Accounting">
                      <FontAwesomeIcon icon={faCalculator} size={!isMobile ? "2x" : "lg"} className="menuIcon" />
                      {/* مالی */}
                    </Link>
                    {accQA.length > 0 &&
                      <ol className='sub-menu'>
                        {accQA.map((qa, i) =>
                          <li className="menu-item" key={i} >
                            <div dangerouslySetInnerHTML={{ __html: qa.Icon }} style={{ textAlign: "center" }}></div>
                            <a href={qa.PageUrl}>{qa.Title}</a> &nbsp;
                            <FontAwesomeIcon icon={faTimesCircle} color='red' onClick={() => removeMenu(qa.PageUrl)} className='mt-1' />
                          </li>
                        )}
                      </ol>
                    }
                  </li>
                }
                {checkSS(16) && (checkModule(appModules, systemModules.Sale) || checkModule(appModules, systemModules.StorageInvoice)) &&
                  <li className="menu-item mainItem">
                    <Link to="/Sale">
                      <FontAwesomeIcon icon={faFileInvoice} size={!isMobile ? "2x" : "lg"} className="menuIcon" />
                      {/* فروش */}
                    </Link>
                    {saleQA.length > 0 &&
                      <ol className='sub-menu'>
                        {saleQA.map((qa, i) =>
                          <li className="menu-item" key={i}>
                            <div dangerouslySetInnerHTML={{ __html: qa.Icon }} style={{ textAlign: "center" }}></div>
                            <a href={qa.PageUrl}>{qa.Title}</a> &nbsp;
                            <FontAwesomeIcon icon={faTimesCircle} color='red' onClick={() => removeMenu(qa.PageUrl)} className='mt-1' />
                          </li>
                        )}
                      </ol>
                    }
                  </li>
                }
                {checkSS(128) && checkModule(appModules, systemModules.CRM) &&
                  <li className="menu-item mainItem">
                    <Link to="/CRM">
                      <FontAwesomeIcon icon={faHeadset} size={!isMobile ? "2x" : "lg"} className="menuIcon" />
                      {/* مشتریان */}
                    </Link>
                    {crmQA.length > 0 &&
                      <ol className='sub-menu'>
                        {crmQA.map((qa, i) =>
                          <li className="menu-item" key={i}>
                            <div dangerouslySetInnerHTML={{ __html: qa.Icon }} style={{ textAlign: "center" }}></div>
                            <a href={qa.PageUrl}>{qa.Title}</a> &nbsp;
                            <FontAwesomeIcon icon={faTimesCircle} color='red' onClick={() => removeMenu(qa.PageUrl)} className='mt-1' />
                          </li>
                        )}
                      </ol>
                    }
                  </li>
                }
                {!isMobile && checkSS(2) && checkModule(appModules, systemModules.BaseInfo) &&
                  <li className="menu-item mainItem">
                    <Link to="/BaseInfo" >
                      <FontAwesomeIcon icon={faSitemap} size={!isMobile ? "2x" : "lg"} className="menuIcon" />
                      {/* تنظیمات */}
                    </Link>
                    {baseInfoQA.length > 0 &&
                      <ol className='sub-menu'>
                        {baseInfoQA.map((qa, i) =>
                          <li className="menu-item" key={i} >
                            <div dangerouslySetInnerHTML={{ __html: qa.Icon }} style={{ textAlign: "center" }}></div>
                            <a href={qa.PageUrl}>{qa.Title}</a> &nbsp;
                            <FontAwesomeIcon icon={faTimesCircle} color='red' onClick={() => removeMenu(qa.PageUrl)} className='mt-1' />
                          </li>
                        )}
                      </ol>
                    }
                  </li>
                }
              </ol>
            </nav>
          </Fragment>
        }
        {pending &&
          <Loader type="BallTriangle" color="#bb1370" height={50} width={50} />}

        {!pending && !currentUser && !forgetPassword && !window.location.href.contains("SMSInvoice") &&

          <Login setUser={setUser} setForgetPassword={setForgetPassword} />}
        <Footer />
      </Router>
    </div >
  );
}

export default App;
